var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.resultsClass},[_c('div',{staticClass:"results__listing"},[_vm._t("default")],2),_c('div',{staticClass:"results__sidebar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }